import * as React from "react";
import {CurrencyAmountDisplay} from "../CurrencyAmountDisplay";
import {useTranslation} from 'react-i18next';
import {AuctionsManager} from "@nextlot/core/webcast";
import {RoundStopTypeEnum, RoundTypeEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";



export default function BidderRoundChoiceLotsSelectCmp(props) {

    const { t, i18n } = useTranslation();

    const [myUserId, setMyUserId] = React.useState<number>(AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId);
    const [selectedLotsIds, setSelectedLotsIds] = React.useState<Array<number>>([]);

    const isLotInputChecked = (lotId: number) => {
        if (props.currentRoundBidding.choiceSelectionSubmitted) {
            const userId = props.currentRoundBidding.choiceLotsSelectionMap.get(lotId);
            return userId === myUserId;
        } else {
            return selectedLotsIds.includes(lotId);
        }
    };

    const handleClick_SelectAll = () => {
        const selectedLotsLength = selectedLotsIds.length;

        if (selectedLotsLength === 0) {
            setSelectedLotsIds(props.currentRound.lotsIds);
        } else {
            setSelectedLotsIds([]);
        }
    };

    const handleChange_LotSelectInputCheckbox = (lotId: number) => (evt) => {
        const newSelectedLotsIds = selectedLotsIds.filter(lId => lId !== lotId);
        const wasSelected = selectedLotsIds.length !== newSelectedLotsIds.length;
        if (!wasSelected) {
            newSelectedLotsIds.push(lotId);
        }

        setSelectedLotsIds(newSelectedLotsIds);
    };

    const handleClick_ButtonSendSelection = (evt) => {
        evt.preventDefault();
        AuctionsManager.currentWebcastAuctionHandler.controller.sendChoiceLotsSelection(props.currentRound.roundId, selectedLotsIds);
    };

    function renderChoiceLotListItem(lotId: number, selectionSubmitted: boolean = false) {
        const lot: Lot = props.auctionDataLotsById.get(lotId);

        const userId = props.currentRoundBidding.choiceLotsSelectionMap.get(lotId);
        const isDisabled = (userId && userId !== myUserId);

        return (
            <div key={lotId} className={`choice-lots__list-item ${isDisabled ? 'bg-danger' : ''}`}>
                <input type="checkbox"
                       onChange={handleChange_LotSelectInputCheckbox(lotId)}
                       checked={isLotInputChecked(lotId)}
                       disabled={selectionSubmitted || isDisabled}
                       value={userId || myUserId}/>

                <span className="list-item__lot-label">
                    <span className="lot-label__no">#{lot.number}</span>
                    <span className="lot-label__name">{lot.name}</span>
                </span>
            </div>
        )

    }



    // if this is a normal CHOICE and this is not the winner, we wait for the winner to make its selection
    if ( (props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE && props.currentRoundBidding.highestBid.userId !== myUserId )
        || (props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN && myUserId < 0) ) {
        return (
            <div
                className="bidder-choice-lots-select-container d-flex flex-column flex-grow-1 justify-content-center">
                {props.currentRound.stopType === RoundStopTypeEnum.SOLD
                    ? <h3>{t('biddingArea.waitingWinner')}</h3>
                    : <h3>{t('biddingArea.pendingSellerConfirmation')} <br/> {t('biddingArea.waitingWinner')}</h3>
                }
            </div>
        )
    }


    // we consider "submitted" when we have our own participantId in the redux.selection
    const selectionSubmitted = props.currentRoundBidding.choiceSelectionSubmitted;
    const choiceLotsSelection = props.currentRoundBidding.choiceLotsSelection;
    const currentRoundLotIds = props.currentRound.lotsIds;

    return (
        <div className="bidder-choice-lots-select-container d-flex flex-column flex-grow-1">
            {
                selectionSubmitted
                    ? <h4>{t('biddingArea.waitAuctioneer')}</h4>
                    : (
                        <React.Fragment>
                            <h4>{
                                props.currentRound.stopType === RoundStopTypeEnum.SOLD
                                    ? (props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN
                                            ? (<span> {t('biddingArea.soldPriceForEach')}: <CurrencyAmountDisplay
                                                valueCents={props.currentRoundBidding.highestBid.value}/></span>)
                                            : `${t('biddingArea.highestBidder')}`
                                    )
                                    : (props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN
                                            ? (<span>{t('biddingArea.pricePendingConfirmation')}: <CurrencyAmountDisplay
                                                valueCents={props.currentRoundBidding.highestBid.value}/></span>)
                                            : `${t('biddingArea.pendingSellerConfirmation')}`
                                    )
                            }

                            </h4>
                            <h5>{t('biddingArea.makeSelections')}:</h5>
                        </React.Fragment>
                    )
            }

            <div className="choice__body">
                {(!selectionSubmitted && (choiceLotsSelection === null || choiceLotsSelection.length !== currentRoundLotIds.length))
                &&
                <a href="#" className="bidder-choice-lots-select-all" onClick={handleClick_SelectAll}>
                    {selectedLotsIds.length === 0
                        ? `${t('common.selectAll')}`
                        : `${t('common.unselectAll')}`
                    }
                </a>
                }

                <div className="choice-lots-list-scrollable-container">
                    {(props.currentRound.lotsIds.map(lotId => renderChoiceLotListItem(lotId, selectionSubmitted)))}
                </div>
            </div>

            <div className="choice__footer mt-3">
                {
                    selectionSubmitted
                        ? <div>{t('biddingArea.selectionSent')}!</div>
                        :
                        <button type="button" onClick={handleClick_ButtonSendSelection}>{t('biddingArea.sendSelection')}</button>
                }
            </div>

        </div>
    )

}

// type RootCmpPropsType = {
//     currentRound: ReduxWebcastCurrentRoundType,
//     currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
//     saleDataLotsById: Map<number, Lot>,
// }
//
// type RootCmpStateType = {
//     selectedLotsIds: Array<number>
// }
//
//
// class BidderRoundChoiceLotsSelectCmp extends React.Component<RootCmpPropsType, RootCmpStateType> {
//
//     constructor(props) {
//         super(props);
//
//         this.myUserId = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId;
//
//         this.state = {
//             selectedLotsIds: []
//         }
//     }
//
//
//     isLotInputChecked = (lotId: number) => {
//         if (this.props.currentRoundBidding.choiceSelectionSubmitted) {
//             const userId = this.props.currentRoundBidding.choiceLotsSelectionMap.get(lotId);
//             return userId === this.myUserId;
//         } else {
//             return this.state.selectedLotsIds.includes(lotId);
//         }
//     };
//
//     handleClick_SelectAll = () => {
//         const selectedLotsLength = this.state.selectedLotsIds.length;
//
//         if (selectedLotsLength === 0) {
//             this.setState({
//                 selectedLotsIds: this.props.currentRound.lotsIds
//             })
//         } else {
//             this.setState({
//                 selectedLotsIds: []
//             })
//         }
//     };
//
//     handleChange_LotSelectInputCheckbox = (lotId: number) => (evt) => {
//         const newSelectedLotsIds = this.state.selectedLotsIds.filter(lId => lId !== lotId);
//         const wasSelected = this.state.selectedLotsIds.length !== newSelectedLotsIds.length;
//         if (!wasSelected) {
//             newSelectedLotsIds.push(lotId);
//         }
//
//         this.setState({
//             selectedLotsIds: newSelectedLotsIds
//         })
//     };
//
//
//     handleClick_ButtonSendSelection = (evt) => {
//         evt.preventDefault();
//         AuctionsManager.currentWebcastAuctionHandler.controller.sendChoiceLotsSelection(this.props.currentRound.roundId, this.state.selectedLotsIds);
//     };
//
//
//     renderChoiceLotListItem(lotId: number, selectionSubmitted: boolean = false) {
//         const lot: Lot = this.props.saleDataLotsById.get(lotId);
//
//         const userId = this.props.currentRoundBidding.choiceLotsSelectionMap.get(lotId);
//         const isDisabled = (userId && userId !== this.myUserId);
//
//         return (
//             <div key={lotId} className={`choice-lots__list-item ${isDisabled ? 'bg-danger' : ''}`}>
//                 <input type="checkbox"
//                        onChange={this.handleChange_LotSelectInputCheckbox(lotId)}
//                        checked={this.isLotInputChecked(lotId)}
//                        disabled={selectionSubmitted || isDisabled}
//                        value={userId || this.myUserId}/>
//
//                 <span className="list-item__lot-label">
//                     <span className="lot-label__no">#{lot.number}</span>
//                     <span className="lot-label__name">{lot.name}</span>
//                 </span>
//             </div>
//         )
//
//     }
//
//
//     render() {
//         const { t } = this.props;
//         // if this is a normal CHOICE and this is not the winner, we wait for the winner to make its selection
//         if ( (this.props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE && this.props.currentRoundBidding.highestBid.userId !== this.myUserId )
//             || (this.props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN && this.myUserId < 0) ) {
//             return (
//                 <div
//                     className="bidder-choice-lots-select-container d-flex flex-column flex-grow-1 justify-content-center">
//                     {this.props.currentRound.stopType === RoundStopTypeEnum.SOLD
//                         ? <h3>{t('biddingArea.waitingWinner')}</h3>
//                         : <h3>{t('biddingArea.pendingSellerConfirmation')} <br/> {t('biddingArea.waitingWinner')}</h3>
//                     }
//                 </div>
//             )
//         }
//
//
//         // we consider "submitted" when we have our own participantId in the redux.selection
//         const selectionSubmitted = this.props.currentRoundBidding.choiceSelectionSubmitted;
//         const choiceLotsSelection = this.props.currentRoundBidding.choiceLotsSelection;
//         const currentRoundLotIds = this.props.currentRound.lotsIds;
//
//
//         return (
//             <div className="bidder-choice-lots-select-container d-flex flex-column flex-grow-1">
//                 {
//                     selectionSubmitted
//                         ? <h4>{t('biddingArea.waitAuctioneer')}</h4>
//                         : (
//                             <React.Fragment>
//                                 <h4>{
//                                     this.props.currentRound.stopType === RoundStopTypeEnum.SOLD
//                                         ? (this.props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN
//                                             ? (<span> {t('biddingArea.soldPriceForEach')}: <CurrencyAmountDisplay
//                                                 valueCents={this.props.currentRoundBidding.highestBid.value}/></span>)
//                                             : `${t('biddingArea.highestBidder')}`
//                                         )
//                                         : (this.props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN
//                                             ? (<span>{t('biddingArea.pricePendingConfirmation')}: <CurrencyAmountDisplay
//                                                 valueCents={this.props.currentRoundBidding.highestBid.value}/></span>)
//                                             : `${t('biddingArea.pendingSellerConfirmation')}`
//                                         )
//                                 }
//
//                                 </h4>
//                                 <h5>{t('biddingArea.makeSelections')}:</h5>
//                             </React.Fragment>
//                         )
//                 }
//
//                 <div className="choice__body">
//                     {(!selectionSubmitted && (choiceLotsSelection === null || choiceLotsSelection.length !== currentRoundLotIds.length))
//                     &&
//                     <a href="#" className="bidder-choice-lots-select-all" onClick={this.handleClick_SelectAll}>
//                         {this.state.selectedLotsIds.length === 0
//                             ? `${t('common.selectAll')}`
//                             : `${t('common.unselectAll')}`
//                         }
//                     </a>
//                     }
//
//                     <div className="choice-lots-list-scrollable-container">
//                         {(this.props.currentRound.lotsIds.map(lotId => this.renderChoiceLotListItem(lotId, selectionSubmitted)))}
//                     </div>
//                 </div>
//
//                 <div className="choice__footer mt-3">
//                     {
//                         selectionSubmitted
//                             ? <div>{t('biddingArea.selectionSent')}!</div>
//                             :
//                             <button type="button" onClick={this.handleClick_ButtonSendSelection}>{t('biddingArea.sendSelection')}</button>
//                     }
//                 </div>
//
//             </div>
//         )
//     }
// }
//
// export default withTranslation()(BidderRoundChoiceLotsSelectCmp);
